<!--
 * @Description  : 快速入库记录
 * @Author       : zhanglei
 * @Date         : 2025-05-13 17:48:09
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-12 15:28:50
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\base-expert-new\index.vue
-->
<template>
	<div class="h100 base-expert-new-layout">
		<filter-layout @search="search" @reset="refresh" hasMore v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchForm" label-width="100px" :model="searchForm">
					<el-form-item label="姓名：" prop="sname">
						<el-input v-model="searchForm.sname" placeholder="请输入姓名" clearable></el-input>
					</el-form-item>
					<el-form-item label="手机号：" label-width="90px" prop="phone">
						<el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable></el-input>
					</el-form-item>
					<el-form-item label="证件号码：" label-width="90px" prop="cardNo">
						<el-input v-model="searchForm.cardNo" placeholder="请输入证件号码" clearable></el-input>
					</el-form-item>
					<el-form-item label="性别：" prop="sex">
						<el-select v-model="searchForm.sex" placeholder="请选择性别" clearable>
							<el-option label="女" :value="0"></el-option>
							<el-option label="男" :value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #more>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchForm" label-width="100px" :model="searchForm">
					<el-form-item label="来源：" prop="dataFrom">
						<el-select v-model="searchForm.dataFrom" placeholder="请选择来源">
							<el-option v-for="item in dwsly" :key="item.value" :label="item.sname" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="跟进状态：" label-width="90px" prop="isFollow">
						<el-select v-model="searchForm.isFollow" placeholder="请选择跟进状态" clearable>
							<el-option label="未跟进" :value="0"></el-option>
							<el-option label="已跟进" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="提交时间：" label-width="90px" prop="time">
						<el-date-picker
							v-model="searchForm.time"
							type="daterange"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							range-separator="-"
							value-format="yyyy-MM-dd HH:mm:ss"
							:default-time="['00:00:00', '23:59:59']"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="年龄：" prop="minAge">
						<div class="flex">
							<el-input v-model="searchForm.minAge" placeholder="请输入" clearable @input="ageChange($event, 'minAge')"></el-input>
							<span class="ml5 mr5">~</span>
							<el-input v-model="searchForm.maxAge" placeholder="请输入" clearable @input="ageChange($event, 'maxAge')"></el-input>
						</div>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<div class="w-table-layout w-table-page mt10">
					<div class="w-table-content">
						<vxe-table
							align="center"
							auto-resize
							border
							:data="tableObj.data"
							:loading="tableObj.loading"
							resizable
							height="100%"
							ref="xTable"
							size="small"
							:row-config="{ isCurrent: true, isHover: true }"
							show-overflow="tooltip"
							show-header-overflow="tooltip"
						>
							<vxe-column type="seq" title="序号" width="70px"></vxe-column>
							<vxe-column title="姓名" field="sname" min-width="100px"></vxe-column>
							<vxe-column title="手机号码" field="phone" min-width="100px"></vxe-column>
							<vxe-column title="证件类型" field="cardTypeName" min-width="100px"></vxe-column>
							<vxe-column title="证件号码" field="cardNo" min-width="200px"></vxe-column>
							<vxe-column title="性别" field="sex" min-width="100px"></vxe-column>
							<vxe-column title="年龄" field="age" min-width="100px"></vxe-column>
							<vxe-column title="来源" field="dataFromName" min-width="100px"></vxe-column>
							<vxe-column title="提交时间" field="createDate" width="160px" min-width="160px"></vxe-column>
							<vxe-column title="跟进状态" field="isFollow" min-width="100px">
								<template slot-scope="scope">
									<el-tag type="success" v-if="scope.row.isFollow == 1">已跟进</el-tag>
									<el-tag type="danger" v-if="scope.row.isFollow == 0">未跟进</el-tag>
								</template>
							</vxe-column>
							<vxe-column title="操作" field="tools" width="180px" min-width="180px">
								<template slot-scope="scope">
									<el-button
										type="success"
										size="small"
										round
										plain
										class="table-btn"
										v-if="scope.row.isFilled === 1"
										@click="tableClick('view', scope.row)"
									>
										<svg-icon icon-class="search"></svg-icon> 查看
									</el-button>
									<el-button type="primary" size="small" round plain class="table-btn" @click="tableClick('record', scope.row)">
										<svg-icon icon-class="form-details"></svg-icon> 跟进记录
									</el-button>
								</template>
							</vxe-column>
						</vxe-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="tableObj.currentPage"
							:page-sizes="tableObj.pageList"
							:page-size="tableObj.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="tableObj.total"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>
		<div v-if="routeQuery">
			<expert-detail :expertId="expertId"></expert-detail>
		</div>

		<!-- 跟进记录 弹窗 -->
		<el-dialog
			:before-close="dialogClose"
			center
			:close-on-click-modal="false"
			:destory-on-close="true"
			:title="dialogObj.title"
			:visible.sync="dialogObj.show"
			:top="dialogObj.followDetail.length !== 0 ? '7vh' : '10vh'"
			width="900px"
		>
			<div class="follow-detail" v-if="dialogObj.followDetail.length !== 0">
				<div class="follow-detail-container" v-for="(item, index) in dialogObj.followDetail" :key="index">
					<i class="el-icon-user-solid"></i>
					<span class="ml20">{{ item.createUser }}</span>
					<span class="ml20">{{ item.createDate }}</span>
					<p class="remark mt10">{{ item.remark }}</p>
				</div>
			</div>
			<el-input
				type="textarea"
				v-model="dialogObj.content"
				placeholder="请输入..."
				:maxlength="200"
				show-word-limit
				:autosize="{ minRows: 5 }"
				class="mb30"
			>
			</el-input>
			<div slot="footer" class="text-center">
				<el-button class="btn" @click="dialogClose">取 消</el-button>
				<el-button class="btn btn-blue" type="primary" @click="dialogSubmit" :loading="dialogObj.loading">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import * as API from '@/api/modules/expert_gz_new.js'
import expertDetail from '@/views/operation-management/base-expert/components/expert-detail.vue'

export default {
	props: {},
	components: { expertDetail },
	data() {
		return {
			searchForm: {
				sname: '', // 姓名
				phone: '', // 手机号
				cardNo: '', // 证件号码
				dataFrom: '', // 来源
				isFollow: '', // 跟进状态  0：未跟进；1：已跟进
				time: [],
				startDate: '', // 提交开始时间
				endDate: '', // 提交结束时间
				sex: '', // 性别 0：女 1：男
				minAge: '', // 最小年龄
				maxAge: '' // 最大年龄
			},
			tableObj: {
				data: [],
				loading: false,
				pageSize: 10,
				currentPage: 1,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			dialogObj: {
				title: '跟进记录',
				show: false,
				loading: false,
				id: '',
				content: '',
				followDetail: []
			},
			expertId: '', // 专家id
			minLastNumber: '',
			maxLastNumber: ''
		}
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchFormNew')) {
				this.searchForm = JSON.parse(this.$getSessionItem('searchFormNew'))

				// 移除 避免污染
				this.$removeSessionItem('searchFormNew')
			}
			if (this.$getSessionItem('expertId')) {
				// 移除 避免污染
				this.$removeSessionItem('expertId')
			}
		}
		this.search()
	},
	mounted() {},
	methods: {
		//查询
		search() {
			let { minAge, maxAge } = this.searchForm
			if (parseFloat(minAge) > parseFloat(maxAge)) {
				this.$message.warning('最小年龄不能大于最大年龄')
				return
			}
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.getTableData()
		},

		//重置
		refresh() {
			this.searchForm = {
				sname: '', // 姓名
				phone: '', // 手机号
				cardNo: '', // 证件号码
				dataFrom: '', // 来源
				isFollow: '', // 跟进状态  0：未跟进；1：已跟进
				time: [],
				startDate: '', // 提交开始时间
				endDate: '', // 提交结束时间
				sex: '', // 性别 0：女 1：男
				minAge: '', // 最小年龄
				maxAge: '' // 最大年龄
			}
			this.searchForm.maxAge = ''

			let { minAge, maxAge } = this.searchForm
			if (parseFloat(minAge) > parseFloat(maxAge)) {
				this.$message.warning('最小年龄不能大于最大年龄')
				return
			}
			this.tableObj.currentPage = 1
			this.tableObj.pageSize = 10
			this.getTableData()
		},

		/********************   准备工作   ********************/
		// 获取表格数据
		getTableData() {
			let params = this.$utils.clone(this.searchForm, true)
			params.startDate = params.time?.[0] || ''
			params.endDate = params.time?.[1] || ''
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			delete params.time

			this.tableObj.loading = false
			API.getPage(params)
				.then((res) => {
					this.tableObj.data = res.data.records
					this.tableObj.total = parseInt(res.data.total)
				})
				.finally(() => {
					this.tableObj.loading = false
				})
		},

		/********************   表格/表单相关   ********************/
		// 年龄change
		ageChange(value, field) {
			const reg = /^\d+$/
			const valueField = field === 'minAge' ? 'minLastNumber' : 'maxLastNumber'
			if (!reg.test(value)) {
				// 如果输入不符合规则，还原为上一次的有效值
				this.$message.warning('只能输入数字！')
				this.searchForm[field] = this[valueField]
				return
			}
			// 更新最后一次有效值
			this[valueField] = value
		},
		// 表格点击事件
		tableClick(type, row) {
			if (type == 'view') {
				this.expertId = row.busId
				this.$setSessionItem('searchFormNew', JSON.stringify(this.searchForm))
				this.$setSessionItem('expertId', JSON.stringify(this.expertId))
				this.$router.push({
					name: 'base-expert-new',
					query: {
						type: 'check'
					}
				})
			} else {
				this.dialogObj.id = row.id
				this.dialogObj.show = true
				API.followDetail({ id: row.id }).then((res) => {
					this.dialogObj.followDetail = res.data
				})
			}
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getTableData()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.tableObj.currentPage = cur
			this.getTableData()
		},

		/********************   弹窗相关  ********************/
		// 弹窗关闭
		dialogClose() {
			this.dialogObj.id = ''
			this.dialogObj.content = ''
			this.dialogObj.show = false
			this.dialogObj.loading = false
		},

		// 弹窗提交
		dialogSubmit() {
			if (this.dialogObj.content === '') {
				this.$message.warning('请输入跟进记录！')
				return
			}
			this.dialogObj.loading = true
			API.followApply({
				id: this.dialogObj.id,
				remark: this.dialogObj.content
			})
				.then((res) => {
					this.dialogClose()
					this.getTableData()
				})
				.finally(() => {
					this.dialogObj.loading = false
				})
		}
	},
	computed: {
		...mapState('app', { isBack: (state) => state.isBack }),
		...mapState('dict', {
			dwsly: (state) => state.projectDict.dwsly
		}),
		routeQuery() {
			return this.$route.query.type
		}
	}
}
</script>

<style lang="less" scoped>
.base-expert-new-layout {
	height: 100%;
	// padding: 20px 20px 0 !important;

	.el-tag {
		height: 28px !important;
		line-height: 26px !important;
	}

	.filter-condition {
		display: flex;
		background-color: #fff;
		padding: 0 10px 15px;
		position: relative;

		.condition-form {
			flex: 1;
		}

		.condition-button {
			margin-left: 10px;
			display: flex;
			align-items: flex-end;
			padding-bottom: 10px;
		}
	}

	.flex {
		display: flex;
	}
}
.follow-detail {
	max-height: 400px;
	overflow-y: auto;
	margin-bottom: 20px;
}
.follow-detail-container {
	padding: 10px 20px;
	background-color: #fafafa;
	border: 1px solid #ebeef5;
	margin-bottom: 10px;
	color: #999;

	i {
		font-size: 20px;
	}
	.remark {
		color: #333;
	}
}
</style>
